import type { LocaleCopy } from '../types';
import { homeDe } from './home';
import { chromeDe } from './chrome';
import { aboutDe } from './about';
import { allergensDe } from './allergens';

export const de: LocaleCopy = {
  home: homeDe,
  chrome: chromeDe,
  about: aboutDe,
  allergens: allergensDe,
};
